import React, { useState, useEffect } from "react";
import SideNavigation from "../../components/dumb/projectManager/SideNavigation";
import useAuthEffect from "../../hook/useAuthEffect";
import { useDispatch, useSelector } from "react-redux";
import { activeModified, emailModified, fetchUsers, firstNameModified, lastNameModified, roleModified, saveUserModifications, userNameModified } from "../../redux/ducks/user";
import useStatusThunk from "../../hook/useStatusThunk";
import { mapData } from "../../helpers/mapRow";
import CreateUser from "../../components/smart/buttonPopups/CreateUser";
import SetUserActive from "../../components/smart/buttonPopups/SetUserActive";
import SetUserPassword from "../../components/smart/buttonPopups/SetUserPassword";
import { Table } from "../../components/dumb/DataTable";
import DeleteUser from "../../components/smart/buttonPopups/DeleteUser";


const UsersRoute = () => {

    const users = useSelector(state => state.user.users);
    const [rows, setRows] = useState([]);
    const [d_fetchUsers, status] = useStatusThunk(fetchUsers);
    const dispatch = useDispatch();

    //Fetch users
    useAuthEffect(isAuth => d_fetchUsers());

    useEffect(() => {
        if (status == "success") setRows(mapData(users));
    }, [status, users]);

    return (
        <div className="columns-container">
            <div className="column column--sidenav">
                <SideNavigation selected="users" />
            </div>

            <div className="column column--primary">
                <Users rows={rows} 
                    userNameModified={(userID, userName) => dispatch(userNameModified({userID, userName}))}
                    firstNameModified={(userID, firstName) => dispatch(firstNameModified({userID, firstName}))}
                    lastNameModified={(userID, lastName) => dispatch(lastNameModified({userID, lastName}))}
                    emailModified={(userID, email) => dispatch(emailModified({userID, email}))}
                    roleModified={(userID, role) => dispatch(roleModified({userID, role}))}
                    activeModified={(userID, active) => dispatch(activeModified({userID, active}))}
                    saveModifications={() => dispatch(saveUserModifications())}
                />
            </div>
        </div >
    )
}

const Users = props => {

    const [checkValues, setCheckValues] = useState([]);

    const renderRow = (row, renderData, extra) =>
        <React.Fragment>
            {renderData(row.ID, { key: "ID" })}
            {extra.renderTextareaData(row.username, { key: "username", onInput: text => { props.userNameModified(row.ID, text) } })}
            {extra.renderTextareaData(row.firstname, { key: "firstname", onInput: text => { props.firstNameModified(row.ID, text) }  })}
            {extra.renderTextareaData(row.lastname, { key: "lastname", onInput: text => { props.lastNameModified(row.ID, text) }  })}
            {extra.renderTextareaData(row.email, { key: "email", onInput: text => { props.emailModified(row.ID, text) }  })}
            {extra.renderTextareaData(row.role, { key: "role", onInput: text => { props.roleModified(row.ID, text) }  })}
            {extra.renderTextareaData(row.active, { key: "active", onInput: text => { props.activeModified(row.ID, text) }  })}
        </React.Fragment>

    const titleContent = <React.Fragment>
        <CreateUser />
        <button className="button" onClick={props.saveModifications}>Save</button>
        <SetUserPassword userID={checkValues[0]} className={checkValues.length == 1 ? "" : "button--disabled"} />
        <DeleteUser userID={checkValues[0]} className={checkValues.length == 1 ? "" : "button--disabled"} />
    </React.Fragment>

    return (
        <Table checkbox={true} newCheckValues={setCheckValues} getCheckValue={row => row.ID} title={"Users"} titleContent={titleContent} renderRow={renderRow} rows={props.rows} cols={[
            { name: "id", sortCol: "ID" },
            { name: "user", sortCol: "username" },
            { name: "first", sortCol: "firstname" },
            { name: "last", sortCol: "lastname" },
            { name: "email", sortCol: "email" },
            { name: "role", sortCol: "role" },
            { name: "active", sortCol: "active" }
        ]} 
        
        getRowAttributes={row => ({
            className: row.modified ? "table__row--modified" : ""
        })}
        
        />
    )
}

export default UsersRoute;